import product1 from "../assets/coffe.svg"
import product2 from "../assets/coffe2.svg"
import product3 from "../assets/coffe3.svg"
import product4 from "../assets/coffe4.svg"

export let dataProduct = [{
        id: 1,
        name: "GUETEMALA Beans",
        price: 27000,
        image: product1,
        stock: 100,
        desc: "Hampir semua referensi sepakat mengatakan bahwa kopi pertama kali ditemukan di Ethiopia, meskipun ada juga beberapa protes yang menyatakan bahwa Coffea arabica sebenarnya muncul pertama kali di bagian selatan Sudan. Karena para gembala Ethiopia adalah manusia pertama yang mengonsumsi kopi—walau saat itu mereka baru mengonsumsi buah/cherry-nya saja, maka gagasan tentang “Ethiopia sebagai tempat asal kopi” pun semakin kuat.",
    },
    {
        id: 2,
        name: "ETHIOPIA Beans",
        price: 25000,
        image: product2,
        stock: 100,
        desc: "Hampir semua referensi sepakat mengatakan bahwa kopi pertama kali ditemukan di Ethiopia, meskipun ada juga beberapa protes yang menyatakan bahwa Coffea arabica sebenarnya muncul pertama kali di bagian selatan Sudan. Karena para gembala Ethiopia adalah manusia pertama yang mengonsumsi kopi—walau saat itu mereka baru mengonsumsi buah/cherry-nya saja, maka gagasan tentang “Ethiopia sebagai tempat asal kopi” pun semakin kuat.",
    },
    {
        id: 3,
        name: "RWANDA Beans",
        price: 25000,
        image: product3,
        stock: 100,
        desc: "Hampir semua referensi sepakat mengatakan bahwa kopi pertama kali ditemukan di Ethiopia, meskipun ada juga beberapa protes yang menyatakan bahwa Coffea arabica sebenarnya muncul pertama kali di bagian selatan Sudan. Karena para gembala Ethiopia adalah manusia pertama yang mengonsumsi kopi—walau saat itu mereka baru mengonsumsi buah/cherry-nya saja, maka gagasan tentang “Ethiopia sebagai tempat asal kopi” pun semakin kuat.",
    },
    {
        id: 4,
        name: "NICARAGUA Beans",
        price: 25000,
        image: product4,
        stock: 100,
        desc: "Hampir semua referensi sepakat mengatakan bahwa kopi pertama kali ditemukan di Ethiopia, meskipun ada juga beberapa protes yang menyatakan bahwa Coffea arabica sebenarnya muncul pertama kali di bagian selatan Sudan. Karena para gembala Ethiopia adalah manusia pertama yang mengonsumsi kopi—walau saat itu mereka baru mengonsumsi buah/cherry-nya saja, maka gagasan tentang “Ethiopia sebagai tempat asal kopi” pun semakin kuat.",
    },
    
];

export let dataIncome = [{
        id: "1",
        name: "Danu",
        address: "jakarta",
        postcode: "87653",
        income: 500000,
        status: "success"
    },
    {
        id: "2",
        name: "Nana",
        address: "Tangerang",
        postcode: "22345",
        income: 29000,
        status: "success"
    },
    {
        id: "3",
        name: "laksa",
        address: "Surabaya",
        postcode: "11123",
        income: 100000,
        status: "ontheway"
    },
    {
        id: "4",
        name: "Panji",
        address: "Semarang",
        postcode: "22555",
        income: 50000,
        status: "waiting"
    },
];

export let dataTransaction = [
    {
        id: 1,
        name: "Boba Milk Tea",
        price: 27000,
        image: product1,
        topping: 'mango boba, bill berry boba',
        qty: 1
    },
    {
        id: 2,
        name: "Ice Coffe Palm Sugar",
        price: 27000,
        image: product1,
        topping: 'mango boba, bill berry boba',
        qty: 1
    }
]